<template>
  <span class="bar-toggle" :class="{ open }" @click="onOpenToggle"><icon :name="open ? 'minus' : 'bars'" /></span>
</template>

<script>
  export default {
    props: ['value'],
    data() {
      return {
        open: false,
      };
    },
    methods: {
      onOpenToggle() {
        this.open = !this.open;
        this.$emit('input', this.open);
      },
    },
    watch: {
      value: {
        immediate: true,
        handler() {
          this.open = this.value;
        },
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../variables';
  .bar-toggle {
    cursor: pointer;
    color: $gray-400;
    &:hover {
      color: $gray-800;
    }
    &.open,
    &.open:hover {
      color: $active;
    }
  }
</style>
